// 导入所有 plateform 模块的国际化文件
import { messages as personalInfoMessages } from '@/lang/plateform/personalInfoLang.js'
import { messages as websiteAccessLogMessages } from '@/lang/plateform/websiteAccessLogLang.js'
import { messages as homePageMessages } from '@/lang/plateform/homePageLang.js'
import { messages as informationMessages } from '@/lang/plateform/informationLang.js'
import { messages as orderMessages } from '@/lang/plateform/orderLang.js'
import { messages as payMessages } from '@/lang/plateform/payLang.js'
import { messages as payResultMessages } from '@/lang/plateform/payResultLang.js'
import { messages as productDetailMessages } from '@/lang/plateform/productDetailLang.js'
import { messages as productMessages } from '@/lang/plateform/productLang.js'
import { messages as registerMessages } from '@/lang/plateform/registerLang.js'
import { messages as addressMessages } from '@/lang/plateform/addressLang.js'
import { messages as cartMessages } from '@/lang/plateform/cartLang.js'
import { messages as loginMessages } from '@/lang/plateform/loginLang.js'

// 合并所有国际化消息
export const messages = {
    en: {
        ...personalInfoMessages.en,
        ...websiteAccessLogMessages.en,
        ...homePageMessages.en,
        ...informationMessages.en,
        ...orderMessages.en,
        ...payMessages.en,
        ...payResultMessages.en,
        ...productDetailMessages.en,
        ...productMessages.en,
        ...registerMessages.en,
        ...addressMessages.en,
        ...cartMessages.en,
        ...loginMessages.en
    },
    zh: {
        ...personalInfoMessages.zh,
        ...websiteAccessLogMessages.zh,
        ...homePageMessages.zh,
        ...informationMessages.zh,
        ...orderMessages.zh,
        ...payMessages.zh,
        ...payResultMessages.zh,
        ...productDetailMessages.zh,
        ...productMessages.zh,
        ...registerMessages.zh,
        ...addressMessages.zh,
        ...cartMessages.zh,
        ...loginMessages.zh
    }
} 